export const lifeCycleEventName = {
    onInit: 'onInit',
    onConfigInit: 'onConfigInit',
    onConfigUpdated: 'onConfigUpdated',
    onCommonDataInit: 'onCommonDataInit',
    onCommonUpdated: 'onCommonUpdated',
    onPageChange: 'onPageChange',
    onDestroy: 'onDestroy,',
};
